import { mapToCanActivate, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { AdminGuard } from './shared/guards/admin.guard';

import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';


export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/dashboards/funding-dashboard/funding-dashboard.component').then(m => m.FundingDashboardComponent),
        pathMatch: 'full',
        title: 'Rise Above Funding | Dashboard',
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/user-pages/profile/profile.component').then(m => m.ProfileComponent),
        title: 'Rise Above Funding | User Profile'
      },
      {
        path: 'children',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/child-pages/children/children.component').then(m => m.ChildrenComponent),
            title: 'Rise Above Funding | Children'
          },
          {
            path: ':id',
            loadComponent: () => import('./pages/child-pages/child/child.component').then(m => m.ChildComponent),
            title: 'Rise Above Funding | Child Profile'
          },
        ]
      },
      {
        path: 'funding-requests',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/request-pages/funding-requests/funding-requests.component').then(m => m.FundingRequestsComponent),
            title: 'Rise Above Funding | Funding Requests'
          },
          {
            path: ':id',
            loadComponent: () => import('./pages/request-pages/funding-request/funding-request.component').then(m => m.FundingRequestComponent),
            title: 'Rise Above Funding | Funding Request'
          },
        ]
      },
      {
        path: 'reports',
        canActivate: mapToCanActivate([AdminGuard]),
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'applications-summary'
          },
          {
            path: 'applications-summary',
            loadComponent: () => import('./pages/report-pages/applications-summary-report/applications-summary-report.component').then(m => m.ApplicationsSummaryReportComponent),
            title: 'Rise Above Funding | Applications Summary Report'
          },
          {
            path: 'by-applicant',
            loadComponent: () => import('./pages/report-pages/by-applicant-report/by-applicant-report.component').then(m => m.ByApplicantReportComponent),
            title: 'Rise Above Funding | Application by Applicant Type Report'
          },
          {
            path: 'by-office',
            loadComponent: () => import('./pages/report-pages/by-office-report/by-office-report.component').then(m => m.ByOfficeReportComponent),
            title: 'Rise Above Funding | Applications by Office Report'
          },
          {
            path: 'race-ethnicity',
            loadComponent: () => import('./pages/report-pages/by-race-ethnicity-report/race-ethnicity-report.component').then(m => m.RaceEthnicityReportComponent),
            title: 'Rise Above Funding | Youth Race & Ethnicity Report'
          },
          {
            path: 'placement',
            loadComponent: () => import('./pages/report-pages/by-placement-report/placement-report.component').then(m => m.PlacementReportComponent),
            title: 'Rise Above Funding | Youth by Placement Type Report'
          },
        ]
      },
      {
        path: 'export',
        canActivate: mapToCanActivate([AdminGuard]),
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'open-requests'
          },
          {
            path: 'open-requests',
            loadComponent: () => import('./pages/report-pages/open-requests-report/open-requests-report.component').then(m => m.OpenRequestsReportComponent),
            title: 'Rise Above Funding | Open Requests Report'
          },
          {
            path: 'decided-requests',
            loadComponent: () => import('./pages/report-pages/decided-requests-report/decided-requests-report.component').then(m => m.DecidedRequestsReportComponent),
            title: 'Rise Above Funding | Decided Requests Report'
          },
        ]
      },
      {
        path: 'users',
        canActivate: mapToCanActivate([AdminGuard]),
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/user-pages/users/users.component').then(m => m.UsersComponent),
            title: 'Rise Above Funding | User Management'
          },
          {
            path: ':username',
            loadComponent: () => import('./pages/user-pages/user/user.component').then(m => m.UserComponent),
            title: 'Rise Above Funding | User Profile'
          },
        ]
      },
    ]
  },
  // auth pages
  {
    path: 'login',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/auth-pages/sign-in/sign-in.component').then(m => m.SignInComponent),
        pathMatch: 'full',
        title: 'Rise Above Funding | Login',
      },
      {
        path: 'new-password',
        loadComponent: () => import('./pages/auth-pages/change-password/change-password.component').then(m => m.ChangePasswordComponent),
        title: 'Rise Above Funding | Change Password'
      },
      {
        path: 'mfa',
        loadComponent: () => import('./pages/auth-pages/mfa/mfa.component').then(m => m.MfaComponent),
        title: 'Rise Above Funding | Two-Factor Authentication'
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./pages/auth-pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
        title: 'Rise Above Funding | Forgot Password'
      },
      {
        path: 'reset-password',
        loadComponent: () => import('./pages/auth-pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
        title: 'Rise Above Funding | Reset Password'
      },
    ]
  },
  // error pages
  {
    path: '**',
    loadComponent: () => import('./pages/error-pages/not-found/not-found.component').then(m => m.NotFoundComponent),
    title: 'Rise Above Funding | Not Found'
  },
];
